import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRoles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1797_1439)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4 7C4 7.7044 3.96725 8.30065 4.58491 9.08302C5.37736 10.0868 5.8065 11.2914 5.24528 11.8302C4.58491 12.4642 3.26415 13.0981 3.26415 15H10.3082C9.79455 14.1547 9.1761 12.8381 9 12.5C8.77987 12.0774 9 11 10 11C10.7044 11 10.7484 9.9283 10.7484 9.08302L11.5 8.5L10.5 7.5V6.5M3 4.5C3 2.63265 4.70329 1 6.5 1C9.25273 1 10.5 2.13265 10.5 4L12.5 5L3 6V4.5Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1797_1439",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgIconRoles;
